module.exports = __webpack_public_path__ + "img/肖像_女@3x.64f81a38.png";